<template>
  <div class="mine">
    <van-popup v-model="customerService">
      <div class="dialog">
        <div class="dialog-title">请加微信</div>
        <div class="dialog-body">15321761517</div>
        <div class="dialog-foot">
          <span class="option" @click="customerService = false">取消</span>
          <a class="option" href="javascript:window.location.href='weixin://'" v-clipboard:copy="'15321761517'" @click="toast()">去微信添加</a>
        </div>
      </div>
    </van-popup>
    <div class="user-info">
      <div class="user-img">
        <img class="user-header" v-if="userInfo.avatar" :src="userInfo.avatar">
      </div>
      <div class="user-name">{{userInfo.userName}},您好</div>
      <!-- <van-button class="comment-detail-btn" round color="#ffd01e" @click="logout()" v-if="signIn">注销</van-button> -->
      <van-button class="comment-detail-btn" round color="#ffd01e" @click="login()" v-if="!signIn">绑定手机号</van-button>
    </div>
    <div class="history">
      <div class="foot" @click="toFoot">
        <div class="foot-number">{{footList?footList.length: '0'}}</div>
        <div class="foot-text">足迹</div>
      </div>
      <div class="collect" @click="toCollection">
        <div class="collect-number">{{collectionNum}}</div>
        <div class="collect-text">收藏</div>
      </div>
    </div>
    <div class="border-card">
      <div class="card-header">我的服务</div>
      <div class="card-border">
        <div class="img-row">
          <div class="img-box" @click="jumpTo('report')">
            <img class="border-img" src="../../assets/img/icon_my_report.png">
            <span class="border-font">我的报告</span>
          </div>
          <div class="img-box" @click="jumpTo('gift')">
            <img class="border-img" src="../../assets/img/icon_my_gift.png">
            <span class="border-font">我的赠礼</span>
          </div>
          <div class="img-box" @click="jumpTo('coupon')">
            <img class="border-img" src="../../assets/img/icon_my_coupon.png">
            <span class="border-font">优惠券</span>
          </div>
          <div class="img-box" @click="jumpTo('comment')">
            <img class="border-img" src="../../assets/img/icon_my_evaluate.png">
            <span class="border-font">我的评价</span>
          </div>
        </div>
        <div class="img-row">
          <div class="img-box" @click="customerService = true">
            <img class="border-img" src="../../assets/img/icon_customer.png">
            <span class="border-font">联系客服</span>
          </div>
          <div class="img-box" @click="customerService = true">
            <img class="border-img" src="../../assets/img/icon_biz.png">
            <span class="border-font">商务合作</span>
          </div>
        </div>
      </div>
    </div>
    <div class="border-card" v-if="Array.isArray(unfinishedList) && unfinishedList.length > 0">
      <div class="card-header">未完成测试</div>
      <div class="card-border">
        <div class="border-detail" v-for="(unfinishedTest,index) in unfinishedList" :key="index">
          <div class="last-time">
            <span>上次完成时间:{{unfinishedTest.createTime}}</span>
          </div>
          <div class="test-detail">
            <div class="img-box">
              <img class="quiz-thumbnail" :src="publicUrl + unfinishedTest.orderQuiz.quizThumbnail">
            </div>
            <div class="quiz-title"><span class="quiz-title-text">{{unfinishedTest.orderQuiz.quizName}}</span></div>
            <div class="quiz-name"><span class="quiz-name-text">{{unfinishedTest.orderQuiz.quizName}}</span></div>
            <div class="go-quiz">
              <van-button class="quiz-btn" color="#ffd01e" @click="goTest(unfinishedTest)">继续测试</van-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import * as api from "@p/api";
  import {
    mapState,
    mapMutations
  } from "vuex";
  import {
    Toast
  } from 'vant';
  import List from "@m/vant/List";
  import publicUrl from "@p/public";
  import Button from "@m/vant/Button";
  import Popup from "@m/vant/Popup";
  export default {
    mixins: [List, Button, Popup],
    data() {
      return {
        publicUrl,
        userInfo: {
          userName: '',
          avatar: ''
        },
        unfinishedList: [],
        collectionNum: 0,
        customerService: false,
        footList: JSON.parse(localStorage.getItem('foot')),
        signIn: false
      };
    },
    computed: {
      ...mapState({
        me_text: state => state.me_text
      })
    },
    beforeRouteEnter(to, from, next) {
      console.log(localStorage.getItem('openId') === null)
      // if ((!localStorage.getItem('openId') || localStorage.getItem('openId') === "" || localStorage.getItem('openId') ===
      //     null) || (!localStorage.getItem('userId') || localStorage.getItem('userId') === "" || localStorage.getItem(
      //     'userId') === null)) {
      //   // alert();
      //   // next(vm => {
      //   //   vm.$router.push("/home");
      //   // });
      // } else {
      //   next();
      // }
      // 注意，在路由进入之前，组件实例还未渲染，所以无法获取this实例，只能通过vm来访问组件实例
      next(vm => {});
    },
    created() {
      this.getUnfinished();
      this.getseen();
    },
    mounted() {
      var userPhone = localStorage.getItem('userPhone')
      if (userPhone && userPhone !== 'null' && userPhone !== null && userPhone !== '') {
        this.userInfo.userName = localStorage.getItem('userPhone')
        this.signIn = true
      } else {
        this.userInfo.userName = '游客'
        // this.userInfo.userName = localStorage.getItem('userName')
        this.signIn = false
      }
      this.userInfo.avatar = localStorage.getItem('avatar');
    },
    methods: {
      async getUnfinished() {
        var unfinished = await api.requestApiByGet("unfinished")
        this.unfinishedList = unfinished.data.buyOrders
      },
      async getseen() {
        var seen = await api.requestApiByGet("seen");
        console.log(seen)
        if (seen.code === 0) {
          localStorage.setItem('collection', seen.data.favQuiz)
          this.collectionNum = JSON.parse(seen.data.favQuiz).length
        }
      },
      goTest(unfinishedTest) {
        this.$router.push({
          path: "know",
          query: {
            quizId: unfinishedTest.orderQuiz.id,
            timeLimit: unfinishedTest.orderQuiz.timeLimit,
            orderId: unfinishedTest.id
          }
        });
      },
      toFoot() {
        this.$router.push({
          name: 'foot'
        })
      },
      toCollection() {
        this.$router.push({
          name: 'collection'
        })
      },
      dataProcessing(val) {
        this.message = this.message + ' ' + val
      },
      doCopy: function(val) {
        this.dataProcessing(val)
        this.$copyText(this.message).then(function(e) {
          alert('Copied')
          console.log(e)
        }, function(e) {
          alert('Can not copy')
          console.log(e)
        })
      },
      logout() {
        localStorage.setItem('openId', '');
        localStorage.setItem('userId', '');
        localStorage.setItem('userPhone', 'null');
        this.$router.push('home');
      },
      login() {
        this.$router.push('/login')
      },
      toast() {
        console.log(1)
        Toast('微信已复制，请在微信内添加好友');
      },
      jumpTo(url) {
        if (!this.signIn) {
          Toast('请先登录');
          return;
        }
        this.$router.push(url)
      }
    }
  };
</script>

<style lang="less" scoped>
  .mine {
    float: left;
    width: 100vw;
    padding-bottom: 70px;
    overflow: scroll;
  }

  .user-info {
    width: 100%;
    height: 25vw;
  }

  .comment-detail-btn {
    float: right;
    margin-right: 7vw;
    margin-top: 10vw;
    height: 5vh;
  }

  .user-img {
    width: 15vw;
    height: 15vw;
    padding: 5vw;
    float: left;

    .user-header {
      border-radius: 50%;
      width: 15vw;
      height: 15vw;
    }
  }

  .user-name {
    float: left;
    margin-top: 10vw;
    line-height: 2;
  }

  .history {
    width: 100%;
    height: 8vh;
  }

  .foot {
    width: 48.5%;
    float: left;

    .foot-number {
      width: 100%;
      border-right: solid 1px #aeaeae;
      text-align: center;
      padding: 5px;
    }

    .foot-text {
      width: 100%;
      text-align: center;
      padding: 5px;
      font-size: 4.3vw;
    }
  }

  .collect {
    width: 48.5%;
    float: left;

    .collect-number {
      width: 100%;
      text-align: center;
      padding: 5px;
    }

    .collect-text {
      width: 100%;
      text-align: center;
      padding: 5px;
      font-size: 4.3vw;
    }
  }

  .border-card {
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
    transition: 0.3s;
    width: 90%;
    margin-top: 10vw;
    margin-left: 5%;
    border-radius: 10px;
    border: #aeaeae 1px;
    background-color: #ffffff;
    float: left;
  }

  .card-header {
    line-height: 3;
    border-bottom: 1px solid #dedede;
    font-weight: bold;
    padding-left: 5%;
  }

  .card-title {
    line-height: 4;
    border-bottom: 1px solid #dedede;
    font-weight: bold;
    font-size: 3vw;
    padding-left: 5%;
  }

  .card-border {
    width: 90%;
    padding: 5%;
    float: left;

    .img-row {
      width: 100%;
      float: left;

      .img-box {
        width: 25%;
        float: left;
        text-align: center;

        .border-img {
          width: 40%;
          height: 8vw;
          margin: 4vw 30% 2vw 30%;
        }

        .border-font {
          font-size: 3.5vw;
          white-space: nowrap; //不换行
          overflow: hidden; //超出隐藏
          text-overflow: ellipsis; //变成...
          width: 100%;
          line-height: 1;
        }
      }
    }

    .border-detail {
      width: 100%;
      float: left;
      line-height: 2;
      border-bottom: 0.3px solid #efefef;
      // font-weight: bold;

      .last-time {
        color: #aeaeae;
        font-size: 3vw;
      }

      .detail-message {
        padding-top: 5vh;
        padding-bottom: 5vh;
      }
    }

    .test-detail {
      padding: 3vw 0vw;
      width: 100%;
      float: left;

      .img-box {
        float: left;
        width: 20vw;
        height: 20vw;

        .quiz-thumbnail {
          width: 20vw;
          height: 20vw;
          border-radius: 7px;
        }
      }

      .quiz-title {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        font-size: 4vw;
        height: 7vw;
        padding-left: 2vw;

        .quiz-title-text {
          height: 6vw;
          line-height: 1.8;
        }
      }

      .quiz-name {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        font-size: 3vw;
        color: #aeaeae;
        height: 8vw;
        padding-left: 2vw;

        .quiz-name-text {
          height: 6vw;
          line-height: 1.5;
        }
      }

      .go-quiz {
        width: 60vw;
        height: 8vw;
        float: left;

        .quiz-btn {
          height: 8vw;
          float: right;
          font-size: 3vw;
        }
      }
    }
  }

  .dialog {
    width: 80vw;
    float: left;
    padding: 3vh 3vw;

    .dialog-title {
      font-size: 5vw;
      line-height: 2;
    }

    .dialog-body {
      font-size: 3vw;
      line-height: 2;
      height: 6vh;
    }

    .dialog-foot {
      font-size: 3vw;
      line-height: 2;

      .option {
        float: right;
        color: #005500;
        margin-left: 10vw;
      }
    }
  }
</style>
